<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Customer Contact Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading
      :title="`Update ${customer_contact.first_name} Contact`"
      class="mb-3"
    >
      <template #right-content>
        <b-button-toolbar key-nav aria-label="Key Customer Contact Actions">
          <b-button
            variant="success"
            class="ml-1 text-white"
            :to="`/customer/${customer_contact.customer_id}`"
            ><i class="fal fa-arrow-left" />
          </b-button>
        </b-button-toolbar>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit customer contact'">
      <template #gated-content>
        <customer-contact-form
          :customer_contact="customer_contact"
          @submit="submit"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import CustomerContactForm from "@/components/crm/customercontact/form/CustomerContactForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { CrmRepositoryFactory } from "@/repositories/crm/CrmRepositoryFactory";
import { customerContactNotifications } from "@/shared/notifications";
import { getModel } from "@/shared/fetch-utils";
import { notificationOptions } from "@/shared/toast-notification-options";

const CustomerContactsRepository = CrmRepositoryFactory.get("customerContacts");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "CustomerContactEdit",
  mixins: [ToastNotifications],
  components: {
    BasicHeading,
    CustomerContactForm,
    PermissionAlertGate,
  },
  data() {
    return {
      loading: true,
      customer_contact_id: this.$route.params.customer_contact_id || null,
      customer_contact: null,
    };
  },
  methods: {
    async submit(form_data) {
      try {
        await CustomerContactsRepository.update(this.customer_contact_id, {
          customer_id: this.customer_contact.customer_id,
          customer_contact_id: this.customer_contact.customer_contact_id,
          ...form_data,
        });

        this.editSuccess();
        this.$router.push(`/customer/${this.customer_contact.customer_id}`);
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.customer_contact = await getModel({
      model_type: "customer_contact",
      id: this.customer_contact_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: customerContactNotifications,
};
</script>
